/**
 * As capacidades que a casca oferece ao web.
 *
 * O Friday tem 27 delas; aqui entram só as que este app precisa, e a lista cresce quando houver
 * uso — cada uma custa um handler nativo em cada plataforma, e uma capacidade sem consumidor é
 * código que ninguém exercita e que quebra sem ninguém notar.
 */
export const BridgeWebEventType = {
  /** Login nativo do Google. Ver o comentário em `session/session-web-event.ts`. */
  Session: 'session',
  /** Navegação: a casca precisa saber onde o web está para tratar o back de hardware. */
  Navigate: 'navigate',
  /** Compartilhar o cartão da volta pelo share sheet do sistema. */
  Share: 'share',
  /** Plataforma, versão do app, versão do SO. */
  DeviceInfo: 'device-info',
} as const;

export type BridgeWebEventType = (typeof BridgeWebEventType)[keyof typeof BridgeWebEventType];

const ALL: readonly string[] = Object.values(BridgeWebEventType);

export function isBridgeWebEventType(value: unknown): value is BridgeWebEventType {
  return typeof value === 'string' && ALL.includes(value);
}
